import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { GET_CONTENT } from './query'

function isRecord (value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function restoreApolloContentSeed (
  client: ApolloClient<NormalizedCacheObject>,
  seed: unknown,
) {
  if (!isRecord(seed)) {
    return
  }
  const { apollo } = seed
  if (!isRecord(apollo) || !apollo.data || !apollo.variables) {
    return
  }
  try {
    client.writeQuery({
      query: GET_CONTENT,
      variables: apollo.variables as Record<string, unknown>,
      data: apollo.data,
    })
  } catch {
    // Cache seed is best-effort; client still falls back to network.
  }
}

export function restoreApolloContentSeeds (
  client: ApolloClient<NormalizedCacheObject>,
  hydrate: Record<string, unknown> | undefined,
) {
  restoreApolloContentSeed(client, hydrate?.detailHero)
  restoreApolloContentSeed(client, hydrate?.spotlightHero)
  const tileRows = hydrate?.memberHomeTileRows
  if (Array.isArray(tileRows)) {
    tileRows.forEach((seed) => {
      restoreApolloContentSeed(client, seed)
    })
  }
}
